import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=b6b18a22&scoped=true&"
import script from "./Notifications.ts?vue&type=script&lang=js&"
export * from "./Notifications.ts?vue&type=script&lang=js&"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=b6b18a22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b18a22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
